import { WidgetContainer } from "@/layout-components/WidgetContainer";
import NewsquawkHeadlines from "@/widget-components/newsquawk-headlines/NewsquawkHeadlines";
import HeadlinesSearchForm from "@/widget-components/newsquawk-headlines/HeadlinesSearchForm";
import { getWidgetById } from "@/utils/widgets";
import useAuth from "@/hooks/useAuth";
import DemoBanner from "@/ui-components/DemoBanner";


function HeadlinesPage() {
  const { authenticated } = useAuth();
  const HeadlinesWidget = getWidgetById("NewsquawkHeadlines");

  return (
    <div className="h-screen flex flex-col">
      {!authenticated && <DemoBanner />}
      <div className="flex-1 min-h-0 p-2">
        {HeadlinesWidget && (
          <WidgetContainer
            widget={HeadlinesWidget}
            searchComponent={HeadlinesSearchForm}
            hideDefaultActions
            onClose={() => { }}
          >
            {(options) => <NewsquawkHeadlines headerOptions={options} />}
          </WidgetContainer>
        )}
      </div>
    </div>
  );
}

export default HeadlinesPage;
